// src/components/Pagination.jsx
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const Pagination = ({
  currentPage = 1,
  totalPages = 1,
  totalRecords = 0,
  itemsPerPage = 10,
  onPageChange,
  showRecordsInfo = true,
}) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const startRecord = (currentPage - 1) * itemsPerPage + 1;
  const endRecord = Math.min(currentPage * itemsPerPage, totalRecords);

  return (
    <div className="p-5 text-end">
      <div className="inline-flex items-center justify-between w-full flex-wrap gap-3">
        {showRecordsInfo && totalRecords > 0 && (
          <p className="text-sm text-gray-600 text-left">
            Records: {startRecord} to {endRecord} of {totalRecords}
          </p>
        )}

        <nav aria-label="Pagination" className="ml-auto">
          <ul className="inline-flex items-center justify-end border-collapse border border-M-text-color/20 rounded-md overflow-hidden bg-white">
            {/* Previous Button */}
            <li>
              <button
                type="button"
                className="table-pagination-item text-gray-700 hover:bg-M-primary-color hover:text-white transition-colors duration-150 disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-gray-400 disabled:cursor-not-allowed flex items-center justify-center p-2"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                title="Previous Page"
              >
                <MdKeyboardArrowLeft size={18} />
              </button>
            </li>

            {/* Page Number Buttons */}
            {getPageNumbers().map((page, index) => {
              if (page === "...") {
                return (
                  <li
                    key={`ellipsis-${index}`}
                    className="table-pagination-item px-3 py-1.5 text-gray-400 select-none flex items-center justify-center border-l border-M-text-color/10"
                  >
                    ...
                  </li>
                );
              }

              const isActive = currentPage === page;
              return (
                <li key={page}>
                  <button
                    type="button"
                    className={`table-pagination-item transition-colors duration-150 font-medium px-3 py-1.5 border-l border-M-text-color/10 ${
                      isActive
                        ? "bg-M-primary-color text-white font-bold"
                        : "text-gray-700 hover:bg-M-primary-color hover:text-white"
                    }`}
                    onClick={() => onPageChange(page)}
                  >
                    {page}
                  </button>
                </li>
              );
            })}

            {/* Next Button */}
            <li>
              <button
                type="button"
                className="table-pagination-item text-gray-700 hover:bg-M-primary-color hover:text-white transition-colors duration-150 disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-gray-400 disabled:cursor-not-allowed flex items-center justify-center p-2 border-l border-M-text-color/10"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                title="Next Page"
              >
                <MdKeyboardArrowRight size={18} />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Pagination;